<!-- Ativo -->
<span class="badge badge-success" *ngIf="situacao === usuarioAtivo.id">{{usuarioAtivo.nome}}</span>

<!-- Inativo -->
<span class="badge badge-danger" *ngIf="situacao === usuarioInativo.id">{{usuarioInativo.nome}}</span>